module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Epostadressen":"The email","har tittat på kandidaten":"has looked at the candidate","för jobbet":"for the job"},"sv":{"Epostadressen":"Epostadressen","har tittat på kandidaten":"har tittat på kandidaten","för jobbet":"för jobbet"}}')
  delete Component.options._Ctor
}
